module.exports = __webpack_public_path__ + "static/media/icon-estoque-produtos.f61a2a82.png";